<template>
  <div
    class="absolute shadow-4 transition-all w-full overflow-hidden rounded-small duration-500 cursor-pointer"
    :class="getScale"
    :style="getStyle"
  >
    <div :class="messageClass" class="flex text-label-large flex-row items-center p-3 pl-4">
      <span class="flex-grow">{{ message.text }}</span>
      <BaseTextButton
        v-if="message.action"
        class="ml-2 text-inverse-primary!"
        size="S"
        @click="message.action.callback"
        >{{ message.action.label }}</BaseTextButton
      >
      <button class="flex items-center justify-center cursor-pointer">
        <BaseIcon>close</BaseIcon>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { type SnackMessage } from '@/core/models/snack'
import { computed } from 'vue'
import BaseIcon from '../icon/BaseIcon.vue'
import BaseTextButton from '../button/text-button/BaseTextButton.vue'

interface Props {
  message: SnackMessage
  position: number
}

const props = defineProps<Props>()

const getStyle = computed(() => ({
  bottom: `${40 + props.position * 8}px`,
  zIndex: 3 - props.position,
}))

const getScale = computed(() => `scale-${100 - props.position * 5}`)

const messageClass = computed(() =>
  props.message.type === 'error'
    ? 'bg-error text-on-error'
    : props.message.type == 'info'
      ? 'bg-inverse-surface text-inverse-on-surface'
      : '',
)
</script>
